const MARKETING_BASE_URL = process.env.REACT_APP_MARKETING_BASE_URL as string;
const VCS_PORTAL_BASE_URL = process.env.REACT_APP_VCS_PORTAL_BASE_URL as string;

const ExternalLinks = Object.freeze({
    MARKETING: {
        HOME: MARKETING_BASE_URL,
        HOSPITALITY: {
            HOME: `${MARKETING_BASE_URL}/virtual-concierge`,
            GET_STARTED: `${MARKETING_BASE_URL}/hospitality/get-started`,
            PRICING: `${MARKETING_BASE_URL}/hospitality/pricing`,
            HOTELS: `${MARKETING_BASE_URL}/hospitality/hotels`,
            VACATION_RENTALS: `${MARKETING_BASE_URL}/hospitality/vacation-rentals`,
            MORE_ADVANCED_FEATURES: `${MARKETING_BASE_URL}/hospitality/more-advanced-features`,
            SEE_IT_IN_ACTION: `${MARKETING_BASE_URL}/hospitality/see-it-in-action`,
            TESTIMONIALS: `${MARKETING_BASE_URL}/hospitality/testimonials`,
            DIFFERENCES_FROM_RETAIL: `${MARKETING_BASE_URL}/hospitality/differences-from-retail-alexa`
        },
        SENIOR_LIVING: {
            HOME: `${MARKETING_BASE_URL}/senior-living`,
            CONTACT: `${MARKETING_BASE_URL}/senior-living#contact-us`,
            OVERVIEW: `${MARKETING_BASE_URL}/senior-living#overview`,
            SOLUTION_IMPACT: `${MARKETING_BASE_URL}/senior-living#solution-impact`,
            DIFFERENCES_FROM_RETAIL: `${MARKETING_BASE_URL}/senior-living#differences-from-retail`
        },
        SUPPORT: {
            HOME: `${MARKETING_BASE_URL}/support`,
            GETTING_STARTED: {
                HOME: `${MARKETING_BASE_URL}/support/get-started`,
                AFH: `${MARKETING_BASE_URL}/support/getting-started/afh-device-management`,
                NON_AFH: `${MARKETING_BASE_URL}/support/getting-started/non-afh-devices/getting-started-with-non-afh-echo-devices`,
                SUBSCRIPTION_CREDITS: `${MARKETING_BASE_URL}/support/getting-started/subscription-credits`
            },
            LEARN: {
                HOME: `${MARKETING_BASE_URL}/support/learn`,
                VOICE_CONTENT: `${MARKETING_BASE_URL}/support/learn/voice-content`,
                DEVICE_MANAGEMENT: `${MARKETING_BASE_URL}/support/learn/device-management`,
                INTEGRATIONS: `${MARKETING_BASE_URL}/support/learn/integrations`,
                COMMUNICATION_FEATURES: `${MARKETING_BASE_URL}/support/learn/communication-features`,
                REPORTING_AND_ANALYTICS: `${MARKETING_BASE_URL}/support/learn/reporting-and-analytics`,
                SETTINGS: `${MARKETING_BASE_URL}/support/learn/settings`
            },
            TROUBLESHOOT: {
                HOME: `${MARKETING_BASE_URL}/support/troubleshoot`,
                AFH: `${MARKETING_BASE_URL}/support/troubleshoot/afh`,
                NON_AFH: `${MARKETING_BASE_URL}/support/troubleshoot/non-afh`,
                FAQ: `${MARKETING_BASE_URL}/support/troubleshoot/faq`
            }
        },
        ABOUT: {
            HOME: `${MARKETING_BASE_URL}/about`,
            PURPOSE: `${MARKETING_BASE_URL}/about#about`,
            TEAM: `${MARKETING_BASE_URL}/about#the-team`,
            NEWS_ROOM: `${MARKETING_BASE_URL}/about#news-room`,
            CONTACT: `${MARKETING_BASE_URL}/about#contact-us`
        },
        PARTNERS: `${MARKETING_BASE_URL}/partners`,
        PRIVACY: `${MARKETING_BASE_URL}/privacy`,
        TERMS: `${MARKETING_BASE_URL}/terms`
    },
    VCS_PORTAL: {
        HOME: VCS_PORTAL_BASE_URL,
        SUBSCRIPTION: `${VCS_PORTAL_BASE_URL}/account#!/subscription`,
        PROPERTIES: `${VCS_PORTAL_BASE_URL}/properties`,
        LOGIN_FROM_TOKEN: `${VCS_PORTAL_BASE_URL}/login-from-token`
    },
    FACEBOOK: 'https://www.facebook.com/AIPEXTechnologies',
    TWITTER: 'https://twitter.com/theAIPEX',
    LINKEDIN: 'https://www.linkedin.com/company/aipex-tech',
    AIPEX_LOGO: 'https://s3.amazonaws.com/images.virtualconciergeservice.com/uploads/aipex_logo_gray.png',
    AIPEX_SIGNUP_LOGO: 'https://s3.amazonaws.com/images.virtualconciergeservice.com/uploads/AIPEX+LOGO+400x184.png'
})

export default ExternalLinks;